<template>
    <div class="step-content-lint-text" v-if="value.promotion_code && value.promotion_title && value.startdate && value.enddate">
        <div class='step-content-line'>
            <p class='text active'>
                <span class="title-step1 kanitfont">{{value.promotion_code}}</span>
                <span class="disciption-step1 kanitfont">{{value.promotion_title}}</span>
                <span class="startdate-step1">{{genDateView(value.startdate,value.enddate)}}</span>
                <span class="field-status-step1">Status</span>
                <span class="data-status-step1" v-if="value.promotion_active">Active</span>
                <span class="data-status-step1" v-else>InActive</span>
            </p>
        </div>
    </div>
    <div class="step-content-lint-text" v-else>
        <div class='step-content-line'>
            <p class='text active'>Select your promotion strategy and fill in basic information about this new promotion</p>
        </div>
    </div>
</template>
<script>
import moment from "moment-timezone"
export default {
	name: 'step-1-data',
	computed: {
		value() {
			return this.$store.getters['pmcreate/value']
		}
	},
	methods:{
		genDateView(startdate,enddate){
			//March 1, 2018 to April 31, 2018
			const date = moment(new Date(startdate));
			const date2 = moment(new Date(enddate));
			return `${date.format('MMMM D, YYYY')} to ${date2.format('MMMM D, YYYY')}`;
		}
	}
}
</script>
